
































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import ReservationCustomerSummary from '@/components/ReservationCustomerSummary.vue';
import ReservationQuoteDetailsPopover from '@/components/ReservationQuoteDetailsPopover.vue';
import Customer from '@/models/Customer';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import Service from '@/models/Service';

const Setup = Vue.extend({
	name: 'ReservationDetails',
	components: {
		ReservationCustomerSummary,
		ReservationQuoteDetailsPopover,
	},
	props: {
		sectionClasses: {
			type: [Array, Object, String],
			default: 'np-mb-4 np-pb-2 md:np-pb-0 np-px-4',
		},
		totalClasses: {
			type: [Array, Object, String],
			default: 'np-border-none np-pb-0',
		},
	},
	computed: {
		...mapState('reservation', ['reservation']),
		...mapGetters(['isLoggedIn']),
		...mapGetters('reservation', ['customer', 'isExistingReservation', 'quote', 'services']),
	},
});

@Component
export default class ReservationDetails extends Setup {
	// Props
	public sectionClasses!: string | string[] | { [className: string]: string };
	public totalClasses!: string | string[] | { [className: string]: string };

	// State
	public reservation!: Reservation;

	// Getters
	public customer!: Customer;
	public isExistingReservation!: boolean;
	public isLoggedIn!: boolean;
	public quote!: Quote;
	public services!: Service[];

	public get hasCustomer(): boolean {
		return !!this.customer.first_name
			|| !!this.customer.last_name
			|| !!this.customer.email;
	}

	public get prepay(): number {
		if (this.reservation.auto_key) {
			return this.quote.prepaid;
		}

		return this.quote.prepay_amount;
	}

	public get checkInDate(): string | null {
		return this.quote.is_event ? this.quote.event_dates[0] : (this.reservation.start_date || null);
	}

	public get checkinFormat(): String {
		let format = 'MMM D, YYYY';

		if (!this.settings.hide_res_start_time_details) {
			format += ' h:mm a';
		}

		return format;
	}

	public get checkOutDate(): string | null {
		return this.quote.is_event ? this.quote.event_dates[1] : (this.reservation.end_date || null);
	}

	public get checkoutFormat(): String {
		let format = '';

		if (!this.settings.hide_res_end_date_details) {
			format += 'MMM D, YYYY';
		}

		if (!this.settings.hide_res_end_time_details) {
			format += ' h:mm a';
		}

		return format;
	}

	public get dueAtLot(): number {
		if (this.reservation.auto_key) {
			return this.quote.balance_due;
		}

		return this.quote.due_at_lot;
	}

	public get dueText(): string {
		if (this.reservation.auto_key && this.reservation.prepaid && this.settings.adjustable_prepay) {
			if (this.quote.balance_due > 0) {
				return 'To be Charged';
			}

			if (this.quote.balance_due < 0) {
				return 'To be Refunded';
			}
		}

		return 'Due at Lot';
	}

	public get systemSettings() {
		return this.$store.getters['location/location'].systemSettings;
	}

	public get settings(): Locations.Settings {
		return this.$store.getters['location/settings'];
	}

	public get shortcodeAttrs(): { [key: string]: string } {
		return this.$store.state.reservation.shortcodeAttrs;
	}
}
